import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconThread",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function h(e, t, i, _, u, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--thread"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Thread",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      d: "M4.666 7.174a.5.5 0 0 1 0 1H3.333a.5.5 0 0 1 0-1h1.333Zm5.5-.673V3.755c-.003-.05-.01-.12-.025-.195-.031-.167-.088-.3-.161-.372-.073-.073-.206-.13-.373-.163A1.494 1.494 0 0 0 9.349 3l-.016.001h-6.75a1.421 1.421 0 0 0-.189.023c-.162.03-.297.086-.374.164-.077.077-.134.212-.164.374a1.424 1.424 0 0 0-.023.242V8.25c.002.048.008.114.022.189.03.16.086.294.165.374a.73.73 0 0 0 .374.166 1.357 1.357 0 0 0 .24.021H8.46L7.313 7.855a.5.5 0 0 1 .707-.707l2 2a.5.5 0 0 1 0 .707l-2 2a.5.5 0 0 1-.707-.707L8.459 10H2.643c-.026 0-.06 0-.102-.002a2.358 2.358 0 0 1-.329-.036c-.248-.046-.613-.157-.899-.442-.286-.286-.396-.652-.441-.9a2.379 2.379 0 0 1-.04-.43l.001-.024V3.808l.001-.102a2.42 2.42 0 0 1 .039-.328c.046-.247.156-.613.44-.897.284-.285.65-.395.897-.44A2.422 2.422 0 0 1 2.64 2h6.694a1.692 1.692 0 0 1 .132.003c.083.004.198.014.327.04.245.046.613.155.894.437.281.28.39.647.437.892a2.509 2.509 0 0 1 .042.429v2.7a.5.5 0 0 1-1 0Zm-3.5-.994a.5.5 0 0 1 0 1H3.333a.5.5 0 0 1 0-1h3.333Zm2-1.666a.5.5 0 0 1 0 1H3.333a.5.5 0 0 1 0-1h5.333Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const g = /* @__PURE__ */ o(c, [["render", h]]);
export {
  g as default
};
//# sourceMappingURL=thread.js.map
